<template>
    <div class="pl-5">
        <button
            class="btn btn-sm btn-default" 
            @click.stop.prevent="changeAllExpended()"
        >
            {{ isAllExpended ? '全部收合' : '全部展開' }}
        </button>
        <button
            class="btn btn-sm btn-default float-right"
            :disabled="previousActions.length == 0"
            @click.stop.prevent="$emit('undoEdit')"
        >
            回上一步
        </button>
        <button
            class="btn btn-sm btn-default float-right"
            :disabled="previousActions.length == 0"
            @click.stop.prevent="$emit('recoverAll')"
        >
            全部復原
        </button>
        <div class="settings-tree">
            <report-setting-tree-node
                v-for="(child, index) in data"
                :key="index"
                :node="child"
                :siblings="data"
                :expanded="isAllExpended"
                :isFirst="index == 0"
                :isLast="index == data.length-1"
                @delete="onDelete"
                @editCoverage="onEditCoverage"
                @beforeModifyNode="onBeforeModifyNode"
            ></report-setting-tree-node>
        </div>
    </div>
</template>

<script>
import ReportSettingTreeNode from './ReportSettingTreeNode.vue';
export default {
    name: "ReportSettingTree",
    components: { ReportSettingTreeNode },
    props: {
        data: {
            type: Array, 
            required: true, 
            default: () => [] 
        },
        previousActions: {
            type: Array, 
            required: true, 
            default: () => [] 
        },
    },
    data() {
        return {
            isAllExpended: false,
        };
    },
    methods: {
        changeAllExpended() {
            this.isAllExpended = !this.isAllExpended;
        },
        onDelete(data) {
            this.$emit('delete', data)
        },
        onEditCoverage(data) {
            this.$emit('editCoverage', data)
        },
        onBeforeModifyNode(type) {
            return this.$emit('beforeModifyNode', type);
        },
    },
    watch: {},
    mounted() {
      
    },
};
</script>

<style lang="scss" scoped>
.settings-tree {
    border: 1px solid #C2C4C7;
    border-radius: 4px;
    padding: 10px;
    height: 600px;
    overflow-y: scroll;
}
</style>